import helpers from "@/helpers";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class DettaglioInfoVoli extends Vue {
	@Prop({ default: () => null })
	datiExtra: string;
	
	created() {
	}

	get datiVolo(){
		var datiExtra = ( (this.datiExtra && typeof this.datiExtra === 'string' && JSON.parse(helpers.fromSafeBase64(this.datiExtra)) ) as any)  || null,
			datiVolo = datiExtra  && datiExtra.datiVolo || null;
			
		return datiVolo;
	}
	
}
